import React, {useState, useEffect,useRef , useCallback} from "react";
import SearchBox from './search-box.tsx';
import { 
  useParams, 
  useNavigate, 
  useLocation, 
} from "react-router-dom";

import { useSearch } from './search.context.tsx';

interface Props {
  label: string;
  variant?: 'minimal' | 'normal' | 'with-shadow' | 'flat';
  [key: string]: unknown;
}

const Search: React.FC<Props> = ({ label, variant, ...props }) => {

  const { searchTerm, updateSearchTerm } = useSearch();
  console.log('context:', useSearch());
  const submitRef = useRef();
  const testCallback = useCallback(() => {
    
    setTimeout(() => { 
      submitRef.current.click();
    }, 2000);
    //
  }, [searchTerm]);

  const location = useLocation()
  const navigate = useNavigate();

  const handleOnChange = (e: any) => {
    const {value} = e.target;
    //console.log("value",value);
    updateSearchTerm(value);
  };

  const onSearch = (e: any) => {
    e.preventDefault();

    const { pathname, search } = location;
    //if (!searchTerm) return;
    updateSearchTerm(searchTerm)
    let path = pathname;
    console.log('path:', path);
    /*if(!path.includes('/search')){
      path = '/search'
    }
    navigate(path);
    */
    
  };

  
function onSetValue(serachtext){
 
  updateSearchTerm(serachtext);
  testCallback();
  //submitRef.current.requestSubmit();
   //
  // submitRef?.current.dispatchEvent(new Event("submit"));

}
  function clearSearch() {
    updateSearchTerm('');
  }

  return (
    <SearchBox
      label={label}
      onSubmit={onSearch}
      onClearSearch={clearSearch}
      onChange={handleOnChange}
      value={searchTerm}
      name="search"
      placeholder={'Search Company'}
      variant={variant}
      onSetValue={onSetValue}
      {...props}
      submitRef={submitRef}
    />
  );
};

export default Search;
